export const SUSPEND_PARTNER = gql`
    mutation SuspendPartner($id: Int!, $suspendReasonDescription: String!) {
        suspendPartner(id: $id, suspendReasonDescription: $suspendReasonDescription) {
            id
            status
        }
    }
`;

export const UN_SUSPEND_PARTNER = gql`
    mutation UnSuspendPartner($id: Int!) {
        unSuspendPartner(id: $id) {
            id
            status
        }
    }
`;
export const UPDATE_PARTNER_LOGO = gql`
    mutation updatePartnerLogo($input: UpdatePartnerLogoInput) {
        updatePartnerLogo(input: $input) {
            id
        }
    }
`;
export const UPDATE_PARTNER_OF_PARTNER_LOGO = gql`
    mutation updatePartnerOfPartnerLogo($input: UpdatePartnerOfPartnerLogoInput) {
        updatePartnerOfPartnerLogo(input: $input) {
            id
        }
    }
`;
